import styled from "styled-components"

export const StyledUl = styled.ul`
  list-style: none;
  text-align: center;
  padding: unset;
`

export const StyledListItem = styled.li`
  position: relative;
  font-family: "sharp_grotesklight_20";
  font-size: ${({ fontSize }) => (fontSize ? fontSize : "16px")};
  line-height: 1.5;
  &::before {
    content: "";
    background-color: #ba9fcb;
    font-weight: 700;
    display: inline-block;
    width: 0.3em;
    height: 0.3em;
    border-radius: 100%;
    transform: translate(-10px, -50%);
  }
`
